// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aAyWk","container":"styles_container__YUDct","title":"styles_title__UtEmn","wrapper":"styles_wrapper__1r1Pv","answer":"styles_answer__2t7mQ"};